import { useEffect, useState } from "react";
import type { Field, HierarchyType, PlaceLimitedValueItem } from "@/entities/form-metadata";
import type { IdHierarchy } from "@/entities/place";
import { useHierarchyInitialization } from "./HierarchyInitializationContext";

interface UseHierarchyInitializeProps {
    field: Field<HierarchyType>;
    isLeaf: boolean;
    locationLevels: IdHierarchy | null;
    onChangeFilter: (selectedItem: PlaceLimitedValueItem) => Promise<void>;
}

export const useHierarchyInitialize = ({
    field,
    isLeaf,
    locationLevels,
    onChangeFilter,
}: UseHierarchyInitializeProps) => {
    const { isInitialized, setInitialized } = useHierarchyInitialization();

    const [initialGpidForCurrentLevel, setInitialGpidForCurrentLevel] = useState<number | undefined>();

    useEffect(() => {
        if (isInitialized.current) return;

        const selectedItem = field.meta.placeLimitedValues?.find((limitedValue) =>
            locationLevels?.includes(limitedValue.gpid),
        );

        if (selectedItem) {
            setInitialGpidForCurrentLevel(selectedItem.gpid);
            onChangeFilter(selectedItem);
        }
        if (isLeaf) setInitialized();
    }, [
        field.meta.placeLimitedValues,
        initialGpidForCurrentLevel,
        isLeaf,
        onChangeFilter,
        isInitialized,
        setInitialized,
        locationLevels,
    ]);

    return { initialGpidForCurrentLevel };
};
